export default __webpack_public_path__ + "video/Webvideo-optMAX.mp4";